import { resetCampaign } from '../../store/redux-slice';
import { buildCampaignListUrl } from '../../../utils/url-builders';
export var closeCampaign = function (params) {
    var campaignListRoute = buildCampaignListUrl({
        session: params.session,
    });
    params.navigate(campaignListRoute);
    params.store.dispatch(resetCampaign({ session: params.session }));
};
